import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { SoggettoPratica } from '../../../../common/models/tipologiche/soggetto-pratica';

export class FascicoloParere extends FascicoloFull {
  dataEmissione: number;
  tipoRichiedente: boolean;
  richiedenteInterno: SoggettoPratica;
  richiedenteEsterno: string;
  richiesta: string;
  sintesiParere: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
